import { toast } from 'sonner';
import i18next from 'i18next';
import { useBigdesImplementationProcessEvaluationStore } from '@/store/bigdes-implementation-process-evaluation.store.js';
import { getIntegrationErrorMessage } from '@/lib/integration-error-message.js';

export class BigdesImplementationProcessEvaluationIntegration {
    constructor(sdkService) {
        this.service = sdkService;
    }

    _getErrorMessage(error, fallbackKey, fallbackDefault) {
        return getIntegrationErrorMessage(error);
    }

    _normalizeList(payload) {
        if (Array.isArray(payload)) return payload;
        if (Array.isArray(payload?.data)) return payload.data;
        return [];
    }

    async fetchAll(params = {}) {
        const store = useBigdesImplementationProcessEvaluationStore.getState();
        store.setLoading(true);
        store.clearError();

        try {
            const merged = { ...store.searchParams, ...params };
            const response = await this.service.getAll({
                page: merged.page,
                pageSize: merged.pageSize,
                search: merged.search || undefined,
                sortBy: merged.sortBy,
                sortOrder: merged.sortOrder,
            });

            const rows = this._normalizeList(response.data);
            store.setItems(rows);
            if (response.pagination) {
                store.setPaginationData({
                    total: response.pagination.total ?? 0,
                    totalPages: response.pagination.totalPages ?? 1,
                    page: response.pagination.page ?? merged.page,
                    pageSize: response.pagination.pageSize ?? merged.pageSize,
                });
            }

            return { success: true, data: rows, pagination: response.pagination };
        } catch (error) {
            const message = this._getErrorMessage(
                error,
                'bigdesApplicationProcessEvaluation:messages.fetchError',
                'Uygulama süreci değerlendirme listesi yüklenemedi',
            );
            store.setError(message);
            toast.error(message);
            return { success: false, error: message };
        } finally {
            store.setLoading(false);
        }
    }

    async update(id, payload) {
        try {
            const response = await this.service.update(id, payload);
            toast.success(
                i18next.t('bigdesApplicationProcessEvaluation:messages.updateSuccess', {
                    defaultValue: 'Record updated',
                }),
            );
            useBigdesImplementationProcessEvaluationStore.getState().updateItemInList(response.data);
            return { success: true, data: response.data };
        } catch (error) {
            const message = this._getErrorMessage(
                error,
                'bigdesApplicationProcessEvaluation:messages.updateError',
                'Güncelleme başarısız',
            );
            toast.error(message);
            return { success: false, error: message };
        }
    }
}
